import { useContext } from "react";
import { AutocompleteInput, BooleanInput, Create, FormDataConsumer, FormTab, ReferenceInput, required, SelectInput, TabbedForm, TextInput } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const ClassCreate = (props) => {

    const context = useContext(AppContext)

    return (
        <Create {...props}>
            <TabbedForm redirect={'list'}>
                <FormTab label={'Dados Gerais'}>

                    {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && (
                        <ReferenceInput label="Unidade" source="institution_branch" reference="institution-branches" perPage={999}
                            filterToQuery={(text) => ({ "institution_branch.name": text })} sort={{ field: "name", order: "ASC" }} validate={[required()]} fullWidth>
                            <AutocompleteInput
                                source="name"
                                emptyText="Todos"
                                optionText={val => `${val?.institution?.name} - ${val?.name}`}
                                optionValue="id"
                                fullWidth
                            />
                        </ReferenceInput>)}
                    <FormDataConsumer>
                        {({ formData, ...rest }) => (
                            <ReferenceInput label="Período letivo" source="academic_period" filter={{ "institution_branch.id": formData?.institution_branch || context.institutionBranch.id }} reference="academic-periods" fullWidth>
                                <SelectInput source="name" optionText={'name'} optionValue={'id'} />
                            </ReferenceInput>
                        )}
                    </FormDataConsumer>
                    <TextInput source="name" label={'Nome'} fullWidth />
                    <TextInput source="description" label={'Descrição'} fullWidth />
                    <BooleanInput label={"Turma com acesso ao Juristta Office?"} source="has_office_access" defaultChecked={true} defaultValue={true} fullWidth />
                </FormTab>
            </TabbedForm>
        </Create>
    )
}

export default ClassCreate;